export enum MedChronEventsTableVariant {
  ALL_EVENTS = 'all-events',
  DETAILED_VIEW = 'detailed-view',
}
